var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-card',{attrs:{"contextual-style":"dark"}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      My Account\n    ")]),_c('div',{attrs:{"slot":"body"},slot:"body"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }